// @flow
import {
    salesCategorySearch,
    outletSalesCategorySearch,
    validateEntityIds as validateEntityIdsApi
} from 'common/middleware/api';
import { injectError } from 'common/redux/actions/error';
import { ApiError } from 'common/modules/api';
export default class SalesCategoriesActions {
    static SET_IS_FETCHING_SALES_CATEGORIES_IN_PROGRESS =
        'SET_IS_FETCHING_SALES_CATEGORIES_IN_PROGRESS';
    static INJECT_SALES_CATEGORIES = 'INJECT_SALES_CATEGORIES';
    static INJECT_OUTLET_SALES_CATEGORIES = 'INJECT_OUTLET_SALES_CATEGORIES';

    static fetchSalesCategories(params: Object, body: Object) {
        return (dispatch: Dispatch<*>) => {
            const { clientId } = params;
            dispatch(
                SalesCategoriesActions.setIsFetchingSalesCategoriesInProgress(
                    clientId,
                    true
                )
            );
            return salesCategorySearch
                .post(params, body)
                .then(response => {
                    dispatch(
                        SalesCategoriesActions.injectSalesCategories(
                            clientId,
                            response.salesCategories
                        )
                    );
                })
                .catch(error => {
                    dispatch(
                        SalesCategoriesActions.setIsFetchingSalesCategoriesInProgress(
                            clientId,
                            false
                        )
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static setIsFetchingSalesCategoriesInProgress(
        clientId: string,
        isFetchingSalesCategoriesInProgress: boolean
    ): Object {
        return {
            type:
                SalesCategoriesActions.SET_IS_FETCHING_SALES_CATEGORIES_IN_PROGRESS,
            response: isFetchingSalesCategoriesInProgress,
            params: {
                clientId
            }
        };
    }

    static injectSalesCategories(
        clientId: string,
        salesCategories: Array<any>
    ): Object {
        return {
            type: SalesCategoriesActions.INJECT_SALES_CATEGORIES,
            response: salesCategories,
            params: {
                clientId
            }
        };
    }

    static injectOutletSalesCategories(
        clientId: string,
        outletSalesCategories: Array<any>
    ): Object {
        return {
            type: SalesCategoriesActions.INJECT_OUTLET_SALES_CATEGORIES,
            response: outletSalesCategories,
            params: {
                clientId
            }
        };
    }

    static fetchOutletSalesCategories(params: Object, body: Object) {
        return (dispatch: Dispatch<*>) => {
            const { clientId } = params;
            dispatch(
                SalesCategoriesActions.setIsFetchingSalesCategoriesInProgress(
                    clientId,
                    true
                )
            );
            return outletSalesCategorySearch
                .post(params, body)
                .then(response => {
                    dispatch(
                        SalesCategoriesActions.injectOutletSalesCategories(
                            clientId,
                            response.salesCategories
                        )
                    );
                })
                .catch(error => {
                    dispatch(
                        SalesCategoriesActions.setIsFetchingSalesCategoriesInProgress(
                            clientId,
                            false
                        )
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static validateEntityIds({ clientId }, body) {
        return (dispatch: Dispatch<*>) => {
            const params = { clientId, entityType: 'SALES_CATEGORY' };
            return new Promise((resolve, reject) => {
                validateEntityIdsApi
                    .post(params, body)
                    .then((response: Array<string>) => {
                        resolve(response);
                    })
                    .catch((error: Error) => {
                        reject(error);
                        if (error instanceof ApiError) {
                            dispatch(injectError(error));
                        } else {
                            throw error;
                        }
                    });
            });
        };
    }
}
